var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('v-slide-y-reverse-transition',{attrs:{"group":""}},_vm._l((_vm.snackbars),function(snackbar,i){return _c('common-snackbar',{key:snackbar.id,style:(`margin-bottom: ${i * 58}px;`),attrs:{"color":snackbar.color,"text":snackbar.text,"id":snackbar.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }